import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { switchMap } from 'rxjs';
import { LanguageRepository, ThemeBaseComponent } from 'src/app/_core';
import { HomeService } from 'src/app/routes/public/modules/home/state/home.service';

@Component({
  standalone: true,
  selector: 'neopos-footer',
  templateUrl: './footer.component.html',
  styles: [':host { display: block; margin-top: auto; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslateModule],
})
export class FooterComponent extends ThemeBaseComponent {
  private readonly _languageRepository = inject(LanguageRepository);
  private readonly _homeService = inject(HomeService);
  private readonly _route = inject(ActivatedRoute);

  getFooterData = toSignal(
    this._route.queryParams.pipe(
      switchMap((queryParams) => {
        if (queryParams['draft'] === 'true') {
          return this._homeService.getFooterData(
            queryParams['locale'],
            Boolean(queryParams['draft'])
          ).result$;
        }

        return this._languageRepository.lang$.pipe(
          switchMap((lang) => this._homeService.getFooterData(lang).result$)
        );
      })
    )
  );
}
